import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { warnOnApiTargetMismatch } from './environments/environment.checks';

warnOnApiTargetMismatch();

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
